import "./SinglePostTemplate.module.css"
import NavegacionPrincipal from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import FooterAbadi from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <NavegacionPrincipal />
      <SinglePostTemplateSection />
      <FooterAbadi />
    </div>
  )
}
